export default __webpack_public_path__ + "static/media/wrong.b382aa2e.svg";